import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

const CLIENTS = ["Government", "PSU", "Corporate", "Hospitals", "Medical Colleges", "Private Organisations"];

export default function ClientsMarquee() {
  return (
    <section className="py-24 lg:py-32 border-t border-white/10 overflow-hidden" data-testid="clients-marquee-section">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="font-mono-accent text-xs tracking-[0.35em] uppercase text-slate-500 text-center mb-14 px-6"
      >
        Delivering for those who build the nation
      </motion.p>
      <Marquee speed={35} gradient={false} pauseOnHover data-testid="clients-marquee">
        {CLIENTS.map((client) => (
          <div key={client} className="flex items-center mx-8 md:mx-14">
            <span className="font-display text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tight text-outline whitespace-nowrap">
              {client}
            </span>
            <Sparkle className="w-6 h-6 md:w-8 md:h-8 text-electric ml-16 md:ml-28" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
